module.exports = __webpack_public_path__ + "img/物流-仓储快递货运标签.749a4371.jpg";